import { CustomTooltip } from '../../CustomTooltip';
import { StatusColor } from '../../StatusColor';
import { RenderComponentProps } from '../types';
import CustomTextLink from './modules/generic/customTextLink';

export type RenderComponent =
  | 'customTextLink'
  | 'customTooltip'
  | 'statusColor';

const cellrenderers = {
  customTextLink: CustomTextLink,
  customTooltip: CustomTooltip,
  statusColor: StatusColor,
};

type RenderFunction = (props: RenderComponentProps) => JSX.Element | string;

export function getCellRenderer(
  component: RenderComponent | RenderFunction | React.FC<RenderComponentProps>,
): any {
  if (typeof component === 'string') {
    return cellrenderers[component];
  }

  return component;
}
